import DialogContentText from '@mui/material/DialogContentText';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

function CommissionsOverrideModal({ open, setOpen, onConfirm, onCancel }) {
  const { t } = useTranslation('navigation');
  const [confirmed, setConfirmed] = useState(false);

  const handleConfirm = async () => {
    setConfirmed(true);
    setOpen(false);
    if (onConfirm) {
      await onConfirm();
    }
  };

  const handleCancel = () => {
    setConfirmed(false);
    setOpen(false);
    if (onCancel) {
      onCancel();
    }
  };

  return (
    <Dialog
      PaperProps={{
        style: {
          backgroundColor: 'white',
          boxShadow: 'none',
        },
      }}
      classes={{
        paper: 'm-24',
      }}
      open={open}
      onClose={handleCancel}
      maxWidth={'sm'}
    >
      <DialogContent className='p-52'>
        <DialogContentText color={'black'}>
          <div className='flex flex-col text-center justify-center'>
            <div className='text-center'>
              <svg
                width='60'
                height='60'
                viewBox='0 0 40 40'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'
                className='inline-block'
              >
                <path
                  fillRule='evenodd'
                  clipRule='evenodd'
                  d='M16.6132 6.9432C18.0893 4.35227 21.9105 4.35226 23.3866 6.9432L36.1735 29.3874C37.6081 31.9055 35.7408 35 32.7868 35H7.21306C4.25902 35 2.39176 31.9055 3.82637 29.3874L16.6132 6.9432ZM21.6665 28.3333C21.6665 29.2538 20.9203 30 19.9998 30C19.0793 30 18.3332 29.2538 18.3332 28.3333C18.3332 27.4129 19.0793 26.6667 19.9998 26.6667C20.9203 26.6667 21.6665 27.4129 21.6665 28.3333ZM21.2498 15C21.2498 14.3096 20.6902 13.75 19.9998 13.75C19.3095 13.75 18.7498 14.3096 18.7498 15V23.3333C18.7498 24.0237 19.3095 24.5833 19.9998 24.5833C20.6902 24.5833 21.2498 24.0237 21.2498 23.3333V15Z'
                  fill='#FF1414'
                />
              </svg>
            </div>
            <Typography variant='h3' className='font-600 text-red'>
              {t('ARE_YOU_SURE') || 'Are You Sure?'}
            </Typography>
            <div className='mt-16'>
              <Typography variant='body1' className='text-black font-500 mb-16'>
                {t('COMMISSIONS_OVERRIDE_WARNING') ||
                  'You are attempting to change the commissions setting for this job, but there are already tickets associated with this job.'}
              </Typography>
              <Typography variant='body2' className='text-black font-400 mb-16'>
                {t('COMMISSIONS_OVERRIDE_REASON') ||
                  'Changing commissions after tickets have been created can affect the calculation of existing tickets and may cause inconsistencies in your billing records.'}
              </Typography>
              <Typography variant='body2' className='text-black font-400'>
                {t('COMMISSIONS_OVERRIDE_CONFIRM') ||
                  'Do you want to proceed with this change anyway?'}
              </Typography>
            </div>
          </div>
        </DialogContentText>
        <Box
          sx={{
            paddingTop: 2,
            display: 'flex',
            flexDirection: 'row',
            m: 'auto',
            width: 'fit-content',
            gap: 2,
          }}
        >
          <Button
            sx={{ color: '#edca33' }}
            variant='contained'
            onClick={handleConfirm}
            disabled={confirmed}
          >
            <Typography fontWeight={'bold'} color={'black'}>
              {t('YES_OVERRIDE') || 'YES, OVERRIDE'}
            </Typography>
          </Button>
          <Button
            variant='contained'
            sx={{ color: '#edca33' }}
            onClick={handleCancel}
            disabled={confirmed}
          >
            <Typography fontWeight={'bold'} color={'black'}>
              {t('CANCEL') || 'CANCEL'}
            </Typography>
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
}

export default CommissionsOverrideModal;
